const PROFILE_ACCOUNT_PAGE_CSS_IDENTIFIERS = Object.freeze({
  block: 'c-profile-account-page',
});

const PROFILE_ACCOUNT_PAGE_CONSTANTS = Object.freeze({
  cssIdentifiers: PROFILE_ACCOUNT_PAGE_CSS_IDENTIFIERS,
});

export { PROFILE_ACCOUNT_PAGE_CONSTANTS };
